<template>
  <header class="sticky top-0 z-[100] bg-white/90 backdrop-blur-md border-b border-gray-100 transition-all duration-300">
    <div class="max-w-7xl mx-auto flex justify-between items-center py-4 px-6 md:px-10">
      
      <div class="text-2xl font-black tracking-tighter text-[#0a0d26]">
        <router-link to="/" class="flex items-center gap-1 text-[#2c3e50]">
          NATUREL<span class="text-[#cd825b]">&</span>JOLI
        </router-link>
      </div>

      <nav class="hidden md:flex items-center space-x-10 p-0">
        <router-link v-for="link in navLinks" :key="link.path" :to="link.path" 
          class="text-[11px] font-black uppercase tracking-[0.2em] text-[#0a0d26] hover:text-[#cd825b] transition-colors nav-link">
          {{ link.name }}
        </router-link>
      </nav>

      <div class="flex items-center space-x-4">
        <template v-if="isLogin">
          <div ref="dropdownContainer" class="relative">
            <button @click.stop="dropdownOpen = !dropdownOpen"
              class="flex items-center gap-3 bg-[#0a0d26] text-white px-5 py-2.5 rounded-full text-[11px] font-black uppercase tracking-widest hover:bg-[#cd825b] transition-all shadow-lg shadow-[#0a0d26]/10">
              <i class="far fa-user-circle text-sm text-[#cd825b]"></i>
              <span class="hidden sm:inline">{{ user.nom }}</span>
              <i class="fas fa-chevron-down text-[10px] transition-transform duration-300" :class="{'rotate-180': dropdownOpen}"></i>
            </button>

            <Transition name="fade-slide">
              <div v-if="dropdownOpen"
                class="absolute right-0 mt-3 w-56 bg-white rounded-2xl shadow-2xl border border-gray-50 py-2 z-[110] overflow-hidden">
                <router-link to="/booking" @click="dropdownOpen = false" class="flex items-center px-6 py-3 text-xs font-bold text-[#0a0d26] hover:bg-gray-50 hover:text-[#cd825b] transition-colors">
                  <i class="far fa-calendar-check mr-3 w-4 text-[#cd825b]"></i> Mes rendez-vous
                </router-link>
                <router-link to="/userAccount" @click="dropdownOpen = false" class="flex items-center px-6 py-3 text-xs font-bold text-[#0a0d26] hover:bg-gray-50 hover:text-[#cd825b] transition-colors">
                  <i class="far fa-user mr-3 w-4 text-[#cd825b]"></i> Mon profil
                </router-link>
                <div class="border-t border-gray-100 my-1"></div>
                <button @click="logout" class="w-full flex items-center px-6 py-3 text-xs font-bold text-red-500 hover:bg-red-50 transition-colors text-left">
                  <i class="fas fa-sign-out-alt mr-3 w-4"></i> Déconnexion
                </button>
              </div>
            </Transition>
          </div>
        </template>

        <template v-else>
          <router-link to="/signup" class="hidden md:block">
            <button class="bg-[#0a0d26] text-white px-8 py-3 rounded-full text-[11px] font-black uppercase tracking-widest hover:bg-[#cd825b] transition-all">
              Mon Compte
            </button>
          </router-link>
        </template>

        <button @click="toggleMenu" class="md:hidden flex flex-col gap-1.5 z-[120] p-2 focus:outline-none">
          <span class="w-6 h-0.5 bg-[#0a0d26] transition-all duration-300" :class="{'rotate-45 translate-y-2 bg-[#cd825b]': isMenuOpen}"></span>
          <span class="w-4 h-0.5 bg-[#0a0d26] self-end transition-all duration-300" :class="{'opacity-0': isMenuOpen}"></span>
          <span class="w-6 h-0.5 bg-[#0a0d26] transition-all duration-300" :class="{'-rotate-45 -translate-y-2 bg-[#cd825b]': isMenuOpen}"></span>
        </button>
      </div>
    </div>
  </header>

  <Transition name="menu-reveal">
    <div v-if="isMenuOpen" class="fixed inset-0 z-[110] bg-white flex flex-col p-10 md:hidden overflow-y-auto">
      <div class="mt-20 space-y-6">
        <router-link v-for="link in navLinks" :key="link.path" :to="link.path" @click="toggleMenu"
          class="block text-4xl font-black text-[#0a0d26] uppercase tracking-tighter hover:text-[#cd825b] transition-colors">
          {{ link.name }}
        </router-link>

        <div class="pt-10 border-t border-gray-100 flex flex-col gap-6">
          <template v-if="isLogin">
            <router-link to="/booking" @click="toggleMenu" class="flex items-center text-xl font-bold text-[#cd825b]">
              <i class="far fa-calendar-check mr-4"></i>Mes rendez-vous
            </router-link>
            <router-link to="/userAccount" @click="toggleMenu" class="flex items-center text-xl font-bold text-[#cd825b]">
              <i class="far fa-user mr-4"></i>Mon compte
            </router-link>
            <button @click="logout(); toggleMenu()" class="text-left text-xs font-black uppercase tracking-widest text-red-500 flex items-center gap-2 pt-4">
              <i class="fas fa-sign-out-alt"></i> Déconnexion
            </button>
          </template>
          <template v-else>
            <router-link to="/signup" @click="toggleMenu"
              class="inline-block text-center bg-[#0a0d26] text-white px-10 py-5 rounded-2xl font-black uppercase tracking-widest text-xs shadow-xl shadow-[#0a0d26]/20">
              Espace Client
            </router-link>
          </template>
        </div>
      </div>
    </div>
  </Transition>

  <router-view/>
  
  <ReviewComponents />

  <section class="mt-20">
    <div class="text-center mb-10">
      <h2 class="text-xs font-black uppercase tracking-[0.3em] text-[#cd825b]">Suivez-nous</h2>
      <p class="text-2xl font-black text-[#0a0d26] mt-2">@NATURELETJOLI</p>
    </div>
    <div class="flex flex-wrap justify-center relative group overflow-hidden">
      <div v-for="i in 6" :key="i" class="w-1/2 sm:w-1/3 md:w-1/6 aspect-square overflow-hidden border-[1px] border-white">
        <img :src="`https://picsum.photos/400/400?random=${i}`" 
          alt="Instagram Feed" 
          class="w-full h-full object-cover transition-transform duration-700 hover:scale-110 hover:brightness-75" />
      </div>
      
      <a href="https://www.instagram.com/Natureletjoli" target="_blank"
        class="absolute bg-white text-[#0a0d26] hover:bg-[#cd825b] hover:text-white transition-all duration-300 rounded-full w-16 h-16 md:w-20 md:h-20 flex justify-center items-center shadow-2xl top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
        <i class="fab fa-instagram text-2xl md:text-3xl"></i>
      </a>
    </div>
  </section>

  <footer class="bg-[#0a0d26] text-white pt-20 pb-10 px-6 md:px-20 mt-10">
    <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 border-b border-gray-800 pb-16">
      
      <div class="space-y-6">
        <h1 class="text-3xl font-black uppercase tracking-tighter">Naturel<span class="text-[#cd825b]">&</span>Joli</h1>
        <p class="text-gray-400 text-sm leading-relaxed">Votre temple de beauté et de bien-être à Taverny. L'expertise au service de votre éclat naturel.</p>
        <div class="flex gap-4">
          <a href="#" class="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-[#cd825b] transition-colors shadow-lg"><i class="fab fa-facebook-f"></i></a>
          <a href="#" class="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-[#cd825b] transition-colors shadow-lg"><i class="fab fa-instagram"></i></a>
        </div>
      </div>

      <div>
        <h2 class="text-[#cd825b] font-black uppercase tracking-widest text-[10px] mb-8">Contact</h2>
        <ul class="space-y-4 text-sm text-gray-300">
          <li class="flex items-center gap-3"><i class="fas fa-phone text-[#cd825b]"></i> 07 61 16 93 08</li>
          <li class="flex items-center gap-3 text-balance leading-relaxed"><i class="fas fa-map-marker-alt text-[#cd825b]"></i> 257 Rue de Paris, 95150 Taverny</li>
          <li class="flex items-center gap-3"><i class="far fa-envelope text-[#cd825b]"></i> contact@natureletjoli.fr</li>
        </ul>
      </div>

      <div>
        <h2 class="text-[#cd825b] font-black uppercase tracking-widest text-[10px] mb-8">Horaires</h2>
        <ul class="space-y-4 text-sm text-gray-300">
          <li class="flex justify-between border-b border-gray-800 pb-2"><span>Lun - Sam</span> <span class="font-bold">9h - 20h</span></li>
          <li class="flex justify-between text-red-400 pt-2"><span>Dimanche</span> <span class="font-bold uppercase">Fermé</span></li>
        </ul>
      </div>

      <div>
        <h2 class="text-[#cd825b] font-black uppercase tracking-widest text-[10px] mb-8">Navigation</h2>
        <nav class="flex flex-col space-y-4 p-0">
          <router-link v-for="link in navLinks" :key="link.path" :to="link.path" class="text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2 group">
            <span class="w-0 group-hover:w-2 h-[1px] bg-[#cd825b] transition-all"></span>
            {{ link.name }}
          </router-link>
          <router-link to="/signup" class="text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2 group">
            <span class="w-0 group-hover:w-2 h-[1px] bg-[#cd825b] transition-all"></span>
            Mon Espace Client
          </router-link>
        </nav>
      </div>
    </div>

    <div class="max-w-7xl mx-auto mt-10 flex flex-col md:flex-row justify-between items-center text-[9px] font-bold uppercase tracking-[0.2em] text-gray-500">
      <p>© 2026 NATUREL & JOLI – TOUS DROITS RÉSERVÉS</p>
      <p class="mt-4 md:mt-0">MADE WITH ♡ BY <span class="text-white">DATAFUSE</span></p>
    </div>
  </footer>

  <button @click="scrollToTop" class="fixed bottom-8 right-8 w-12 h-12 bg-[#cd825b] hover:bg-[#0a0d26] text-white rounded-full shadow-2xl flex items-center justify-center transition-all z-50 group active:scale-90">
    <i class="fas fa-arrow-up group-hover:-translate-y-1 transition-transform"></i>
  </button>
</template>

<style scoped>
/* Transition Dropdown */
.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Transition Menu Mobile */
.menu-reveal-enter-active, .menu-reveal-leave-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.menu-reveal-enter-from, .menu-reveal-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.no-scrollbar::-webkit-scrollbar { display: none; }
</style>

<script>
import ReviewComponents from './components/ReviewComponents.vue';

export default {
  components: { ReviewComponents },
  data() {
    return {
      isMenuOpen: false,
      isLogin: false,
      dropdownOpen: false,
      navLinks: [
        { name: 'Accueil', path: '/' },
        { name: 'Nos Services', path: '/categorie' },
        { name: 'Rendez-vous', path: '/rendez-vous' },
      ],
      user: { nom: '', prenom: '', id: '' },
    };
  },
  mounted() {
    this.checkAuth();
    window.addEventListener('client-login-success', this.checkAuth);
    // Fermer le dropdown si on clique ailleurs
    window.addEventListener('click', this.closeDropdownExternally);
  },
  beforeUnmount() {
    window.removeEventListener('client-login-success', this.checkAuth);
    window.removeEventListener('click', this.closeDropdownExternally);
  },
  watch: {
    $route() {
      // Fermer le dropdown et le menu mobile lors du changement de route
      this.dropdownOpen = false;
      this.isMenuOpen = false;
      document.body.style.overflow = 'auto';
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      this.dropdownOpen = false; // Fermer le dropdown quand on ouvre le menu
      if (this.isMenuOpen) document.body.style.overflow = 'hidden';
      else document.body.style.overflow = 'auto';
    },
closeDropdownExternally(e) {
  // On récupère l'élément via la ref
  const dropdown = this.$refs.dropdownContainer;

  // Si le clic est en dehors de l'élément ref, on ferme
  if (dropdown && !dropdown.contains(e.target)) {
    this.dropdownOpen = false;
  }
},
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    logout() {
      localStorage.removeItem('clientToken');
      this.isLogin = false;
      this.dropdownOpen = false;
      this.user = { nom: '', prenom: '', id: '' };
      document.body.style.overflow = 'auto';
    },
    checkAuth() {
      const token = localStorage.getItem('clientToken');
      if (token) {
        fetch('https://natureletjoli-c64a9b4f6da0.herokuapp.com/api/clients/verify-token', {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.message === 'Token valide') {
              this.isLogin = true;
              this.user = { nom: data.user.nom, prenom: data.user.prenom, id: data.user.id };
              localStorage.setItem('USERID', data.user.id);
            } else {
              this.logout();
            }
          })
          .catch(() => this.logout());
      } else {
        this.logout();
      }
    },
  },
};
</script>

<style>
/* FONT SETUP */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&family=Playfair+Display:wght@700&display=swap');

body {
  font-family: 'Playfair Display', serif;
  color: #0a0d26;
  background-color: #fff;
}

/* Animations transition */
.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-enter-from { opacity: 0; transform: translateY(10px); }
.fade-slide-leave-to { opacity: 0; transform: translateY(10px); }

/* Mobile Menu Circle Reveal */
.menu-reveal-enter-active, .menu-reveal-leave-active {
  transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1);
}
.menu-reveal-enter-from, .menu-reveal-leave-to {
  clip-path: circle(0% at 90% 5%);
}
.menu-reveal-enter-to, .menu-reveal-leave-from {
  clip-path: circle(150% at 90% 5%);
}

/* Custom Nav underline effect */
.nav-link {
  position: relative;
}
.nav-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -4px;
  left: 0;
  background-color: #cd825b;
  transition: width 0.3s ease;
}
.nav-link:hover::after, .router-link-exact-active.nav-link::after {
  width: 100%;
}

.router-link-exact-active.nav-link {
  color: #cd825b !important;
}
</style>